import React, { useEffect, useMemo, useState } from 'react'
import { useParams } from 'react-router-dom'

import Box from '@material-ui/core/Box'
import CircularProgress from '@material-ui/core/CircularProgress'

import { getVendorId } from '../services/vendor-details/actions'
import { useDispatch, useSelector } from 'react-redux'

import { addVendor } from 'services/searches/actions'

import {
  getVendorInfo,
  getCountriesInfo,
  getCPVInfo,
  getIsPruebaFetching,
} from '../services/vendor-details/selectors'
import { getSearchConfig } from '../services/config/selectors'

import Vendor from '../ui/pages/vendor/index'

const PREV_LOCATIONS_TEXT = {
  home: 'navigation:home',
  savedSearch: 'navigation:saved-search',
  search: 'navigation:search',
  vendors: 'navigation:vendors',
  default: 'navigation:back',
}

const VendorDetails = props => {
  const dispatch = useDispatch()
  const vendor = useSelector(getVendorInfo)
  const countriesInfo = useSelector(getCountriesInfo)
  const CPVInfo = useSelector(getCPVInfo)
  const isFetching = useSelector(getIsPruebaFetching)
  const procurementInfo = useSelector(getSearchConfig)
  const [isInMyNetwork, setIsInMyNetwork] = useState(false)

  const goBackMessage = useMemo(() => {
    const prevLocation = props.location.state && props.location.state.from
    const message = PREV_LOCATIONS_TEXT[prevLocation || 'default']
    const params = (props.location.state && props.location.state.params) || {}

    return { message, params }
  }, [props.location.state])

  let { id } = useParams()

  const handleAddVendor = () => {
    setIsInMyNetwork(true)
    dispatch(addVendor(vendor.identification_code, true))
  }

  const checkForEmptyVendorValues = () => {
    if (vendor !== null) {
      if (vendor.business_group === undefined) {
        vendor.business_group = {
          identification_code: '',
          name: '',
          country_code: '',
        }
      }
      if (vendor.documents === undefined) {
        vendor.documents = { own: [], certificates: [], required: [] }
      }
      if (vendor.documents.own === undefined) {
        vendor.documents.own = []
      }
      if (vendor.documents.certificates === undefined) {
        vendor.documents.certificates = []
      }
      if (vendor.cpv === undefined) {
        vendor.cpv = []
      }
      if (vendor.vendor_types === undefined) {
        vendor.vendor_types = []
      }
    }
  }

  const getIncludedStates = () => {
    const spainStatesInfo = getSpainStatesInfo()
    const vendorScopesOfAction = vendor.scopes_of_action
      ? vendor.scopes_of_action
      : []
    const listOfValidCountries = vendorScopesOfAction.map(stateObject => {
      return spainStatesInfo.find(state => state.id === stateObject.state)
    })
    const validCodes = listOfValidCountries.map(country =>
      country.code.toUpperCase(),
    )
    return validCodes
  }

  const getTypeFromCPVId = (ids, CPVInfo) => {
    let allSubLevels = []
    let allSubSubLevels = []
    let allLevels = []

    CPVInfo.forEach(level => {
      if (level.sublevel) {
        allSubLevels = [...allSubLevels, ...level.sublevel]
      }
    })

    allSubLevels.forEach(level => {
      if (level.sublevel) {
        allSubSubLevels = [...allSubSubLevels, ...level.sublevel]
      }
    })

    allLevels = [...allSubSubLevels, ...allSubLevels, ...CPVInfo]

    const completedCPVInfo = ids
      .map(element => {
        return allLevels.find(info => info.id === element.id)
      })
      .map(element => {
        return { ...element, icon: element.type }
      })

    return completedCPVInfo
  }

  const getVendorTypes = types => {
    if (!procurementInfo.vendorTypes) {
      return []
    }

    return types.map(element => {
      return {
        id: element,
        icon: 'type',
        name: procurementInfo.vendorTypes.filter(
          vendorType => vendorType.id === element,
        )[0].name,
      }
    })
  }

  const getSpainStatesInfo = () =>
    countriesInfo.find(country => country.code === 'ES').states

  useEffect(() => {
    dispatch(getVendorId(id))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (vendor) {
      setIsInMyNetwork(vendor.is_in_my_network)
    }
  }, [vendor])

  const renderComponent = () => {
    let formattedStateCodes
    let completedCPVInfo
    let vendorTypes
    checkForEmptyVendorValues()
    if (countriesInfo) {
      formattedStateCodes = getIncludedStates()
    }
    if (CPVInfo) {
      completedCPVInfo = getTypeFromCPVId(vendor.cpv, CPVInfo)
    }

    if (vendor.vendor_types) {
      vendorTypes = getVendorTypes(vendor.vendor_types)
    }

    return (
      <Vendor
        isLoading={isFetching}
        name={vendor.name}
        avatarImage={vendor.image_url}
        identificationCode={vendor.identification_code}
        homologated={vendor.homologated}
        isInMyNetwork={isInMyNetwork}
        documentsRequired={vendor.documents.required}
        documentsOwn={vendor.documents.own}
        certificates={vendor.documents.certificates}
        businessGroup={vendor.business_group}
        businessContact={vendor.business_contact}
        capitalStock={vendor.capital_stock}
        dateOfIncorporation={vendor.date_of_incorporation}
        turnOverAmount={vendor.turnover ? vendor.turnover.amount : null}
        turnOverYear={vendor.turnover ? vendor.turnover.year : null}
        overallNumberStaff={vendor.overall_number_of_staff}
        productsAndServices={completedCPVInfo}
        checkedProvinces={formattedStateCodes}
        vendorTypes={vendorTypes}
        onAddVendor={handleAddVendor}
        goBackMessage={goBackMessage}
      />
    )
  }

  return (
    <>
      {!vendor ? (
        <Box
          height="100vh"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <CircularProgress color="secondary" />
        </Box>
      ) : (
        renderComponent()
      )}
    </>
  )
}

export default VendorDetails
